var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleAlertOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5ZM9 10.9497C8.50297 10.9497 8.09985 11.3528 8.09985 11.8498C8.09993 12.3468 8.50297 12.75 9 12.75C9.49703 12.75 9.90007 12.3469 9.90015 11.8498C9.90015 11.3528 9.49703 10.9497 9 10.9497ZM9 5.25C8.40263 5.25001 7.94085 5.77349 8.01487 6.36621L8.3679 9.19193C8.4078 9.51075 8.6787 9.75 9 9.75C9.3213 9.75 9.5922 9.51075 9.6321 9.19193L9.98588 6.36621C10.0598 5.77352 9.5973 5.25 9 5.25Z",
    fill: "#F38415"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleAlertOrange);
export default __webpack_public_path__ + "static/media/circle-alert-orange.e398c1fb38623846c605f8b70b3dd2dc.svg";
export { ForwardRef as ReactComponent };